import { OfficeAdapters } from '../adapters';
import { UsersApi } from '../clients';

/**
 * GOTU-5263 — fetch the DNT office contract and reshape it into the office slice
 * to overlay onto `currentUser`. Business layer: it owns the wire→view
 * transform (via `toOfficeSlice`). Failures (incl. 404) propagate; the
 * best-effort fallback to the monolith read is the thunk's responsibility.
 *
 * @param {string} officeId - the office's user id
 * @returns {Promise<object>} the office slice
 */
export const getOffice = async (officeId) => {
  const contract = await UsersApi.getOffice(officeId);

  return OfficeAdapters.toOfficeSlice(contract);
};
